import React, { Component } from "react";
import {
  Button,
  Container,
  Form,
  Card,
  Row,
  Col,
  Modal,
  Image,
  Table
} from "react-bootstrap";
import "../Common/Common.css";
import ReactPaginate from "react-paginate";
import PaymentsView from "./PaymentsView";
import { DropdownButton, OverlayTrigger, Tooltip } from "react-bootstrap";
var dateFormat = require("dateformat");

class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPaymentModal: false,

      searchPay: "",
      filterPay: "",

      page: 0,
      perPage: 10
    };
  }

  componentDidMount() {
    this.props.getPayments({
      page: undefined,
      search: this.state.searchPay,
      filter: this.state.filterPay
    });
  }

  showPayModal = item => {
    this.setState({
      ...this.state,
      showPaymentModal: true,
      paymentDetail: item
    });
  };

  closePayModal = () => {
    this.setState({
      ...this.state,
      showPaymentModal: false
    });
  };

  //For pagination
  handlePayPageClick = e => {
    const selectedPayPage = e.selected;
    this.props.PaypageSelected({
      page: selectedPayPage + 1,
      search: this.state.searchPay,
      filter: this.state.filterPay
    });
    this.setState({ page: selectedPayPage });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  //For Filter
  payFilterChange = ev => {
    this.setState(
      {
        ...this.state,
        page: 0,
        searchPay: "",
        filterPay: ev.target.value
      },
      () => {
        this.props.PaypageSelected({
          page: undefined,
          search: "",
          filter: this.state.filterPay
        });
      }
    ); //synchronous call
  };

  //For search
  paySearch = ev => {
    this.setState(
      {
        ...this.state,
        page:0,
        searchPay: ev.target.value,
        filterPay: ""
      },
      () => {
        this.props.PaypageSelected({
          page: undefined,
          search: this.state.searchPay,
          filter: ""
        });
      }
    ); //synchronous call
  };

  renderTooltip = props => (
    <Tooltip id="button-tooltip" {...props}>
      View
    </Tooltip>
  );

  render() {
    //Destructuring
    const { paymentsList, paymentsListCount } = this.props;
    const {
      showPaymentModal,
      page,
      perPage,
      filterPay,
      searchPay
    } = this.state;
    const {
      payFilterChange,
      paySearch,
      resetPage,
      handlePayPageClick,
      closePayModal,
      showPayModal
    } = this;

    console.log(paymentsList);
    //For Pagination
    const count = paymentsListCount;
    let p = page + 1;
    let payPageCount = Math.ceil(count / perPage);

    return (
      <div className="salesreturndiv">
        <Card>
          {/* <Card.Header className="commontableheader"> */}
          <div className="salesheader">
            <Row>
              <Col xs={12} sm={12} md={3} lg={3}>
                {/* <h5 className="commontableheadername">Receipts</h5> */}
                <div>
                  <h5 className="tablecardtitle">Receipts</h5>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonInputdiv">
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                    <input
                      type="text"
                      placeholder="Reference Number"
                      value={searchPay}
                      onChange={paySearch}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                {/* <div className="commonFilterDiv">
                  <select
                    value={filterPay}
                    onChange={payFilterChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    <option value="open">Open</option>
                    <option value="partial">Partial</option>
                    <option value="paid">Paid</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div> */}
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="salescommonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {paymentsListCount === undefined ? (
                      0
                    ) : (
                      <span>{paymentsListCount}</span>
                    )}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </div>
          {/* </Card.Header> */}
          <Card.Body className="tableCardBody">
            <div className="tablecommonCardBody">
              <Table hover responsive className="">
                <thead className="tablecommonCard">
                  <tr>
                    <th>#</th>
                    <th>Reference No</th>
                    <th>Order ID</th>
                    {/* <th>Chemist Name</th> */}
                    <th>Organization Name</th>
                    <th>Payment Mode</th>
                    <th>Amount</th>
                    {/* <th>Payment Type</th> */}
                    <th>Created Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                {paymentsList !== undefined &&
                  paymentsListCount !== 0 &&
                  paymentsList.map((item, i) => (
                    <tbody key={i} className="tableBody">
                      <tr>
                        <td>{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">{item && item.invNo}</td>
                        <td className="cmn_Cap">
                          {item && item.orderId && item.orderId.orderNo}
                        </td>
                        {/* <td className="cmn_Cap"></td> */}
                        <td className="cmn_Cap">
                          {item && item.orderId && item.orderId.orderFromName}
                        </td>
                        <td className="cmn_Cap">
                          {item && item.orderId && item.orderId.payMode}
                        </td>
                        <td className="cmn_Cap">{item && item.paidAmnt?"INR "+item.paidAmnt:null}</td>
                        {/* <td className="cmn_Cap">
                          {item && item.orderId && item.orderId.payType}
                        </td> */}
                        <td>
                          {item && dateFormat(item.createdAt, "dd-mmm-yyyy")}
                        </td>
                        <td className="cmn_Cap"><span className="badge badge-success">{item && item.status}</span></td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center"
                            }}
                          >
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderTooltip}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() => showPayModal({ item: item })}
                              ></i>
                            </OverlayTrigger>

                            {/* <i
                              className="fa fa-eye fa-lg "
                              onClick={() => showPayModal({ item: item })}
                            ></i> */}
                            <PaymentsView
                              show={showPaymentModal}
                              close={closePayModal}
                              paymentDetail={this.state.paymentDetail}
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  ))}
              </Table>
              {payPageCount > 1 ? (
                <div className="paginationDiv">
                  <ReactPaginate
                    forcePage={page}
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={payPageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePayPageClick}
                    containerClassName={"pagination flex-wrap"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                  />
                </div>
              ) : null}
              {(paymentsList === undefined ||
                (paymentsList && paymentsListCount === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No receipts found</div>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default Payments;
